import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SliceActions } from '../types';
import { ERequestApiStatus } from '../../types/appState';
import { TUserProfileState } from '../../types/chatProfile';
import { IUserProfileClientInfo } from '../../types/userProfile';

const initialState: TUserProfileState = {};

const userProfileSlice = createSlice({
  name: 'userProfile',
  reducers: {
    setUserProfilePending: (state, action: PayloadAction<{ chatId: string }>) => {
      const { chatId } = action.payload;

      state[chatId] = {
        clientInfo: state[chatId]?.clientInfo ?? null,
        status: ERequestApiStatus.Pending,
      };
    },
    setUserProfileSucceed: (
      state,
      action: PayloadAction<{ chatId: string; clientInfo: IUserProfileClientInfo | null }>,
    ) => {
      const { chatId, clientInfo } = action.payload;

      state[chatId] = {
        clientInfo,
        status: ERequestApiStatus.Succeed,
      };
    },
    setUserProfileFailed: (state, action: PayloadAction<{ chatId: string }>) => {
      const { chatId } = action.payload;

      state[chatId] = {
        clientInfo: state[chatId]?.clientInfo ?? null,
        status: ERequestApiStatus.Failed,
      };
    },
  },
  initialState,
});

export const userProfileReducer = userProfileSlice.reducer;
export const { setUserProfilePending, setUserProfileSucceed, setUserProfileFailed } = userProfileSlice.actions;
export type TUserProfileActions = SliceActions<typeof userProfileSlice.actions>;
